import i18n from '@ohif/i18n';

export const _editorMode = {
  default: "default", // Custom
  import: "import" // Import Template
}

export const _reportStatus = {
  Draft: "Draft",
  Completed: "Completed",
  Authorized: "Authorized",
  SentForReview: "Sent for Review",
}

export const _studyReviewStatus = {
  REJECTED:'REJECTED',
  ACCEPTED:'ACCEPTED'
}

export const _modalitySelect = {
  name: 'modalities',
  displayName: i18n.t('StudyList:Modality'),
  inputType: 'MultiSelect',
  inputProps: {
    options: [
      { value: 'AR', label: 'AR' },
      { value: 'ASMT', label: 'ASMT' },
      { value: 'AU', label: 'AU' },
      { value: 'BDUS', label: 'BDUS' },
      { value: 'BI', label: 'BI' },
      { value: 'BMD', label: 'BMD' },
      { value: 'CR', label: 'CR' },
      { value: 'CT', label: 'CT' },
      { value: 'CTPROTOCOL', label: 'CTPROTOCOL' },
      { value: 'DG', label: 'DG' },
      { value: 'DOC', label: 'DOC' },
      { value: 'DX', label: 'DX' },
      { value: 'ECG', label: 'ECG' },
      { value: 'EPS', label: 'EPS' },
      { value: 'ES', label: 'ES' },
      { value: 'FID', label: 'FID' },
      { value: 'GM', label: 'GM' },
      { value: 'HC', label: 'HC' },
      { value: 'HD', label: 'HD' },
      { value: 'IO', label: 'IO' },
      { value: 'IOL', label: 'IOL' },
      { value: 'IVOCT', label: 'IVOCT' },
      { value: 'IVUS', label: 'IVUS' },
      { value: 'KER', label: 'KER' },
      { value: 'KO', label: 'KO' },
      { value: 'LEN', label: 'LEN' },
      { value: 'LS', label: 'LS' },
      { value: 'MG', label: 'MG' },
      { value: 'MR', label: 'MR' },
      { value: 'M3D', label: 'M3D' },
      { value: 'NM', label: 'NM' },
      { value: 'OAM', label: 'OAM' },
      { value: 'OCT', label: 'OCT' },
      { value: 'OP', label: 'OP' },
      { value: 'OPM', label: 'OPM' },
      { value: 'OPT', label: 'OPT' },
      { value: 'OPTBSV', label: 'OPTBSV' },
      { value: 'OPTENF', label: 'OPTENF' },
      { value: 'OPV', label: 'OPV' },
      { value: 'OSS', label: 'OSS' },
      { value: 'OT', label: 'OT' },
      { value: 'PLAN', label: 'PLAN' },
      { value: 'PR', label: 'PR' },
      { value: 'PT', label: 'PT' },
      { value: 'PX', label: 'PX' },
      { value: 'REG', label: 'REG' },
      { value: 'RESP', label: 'RESP' },
      { value: 'RF', label: 'RF' },
      { value: 'RG', label: 'RG' },
      { value: 'RTDOSE', label: 'RTDOSE' },
      { value: 'RTIMAGE', label: 'RTIMAGE' },
      { value: 'RTINTENT', label: 'RTINTENT' },
      { value: 'RTPLAN', label: 'RTPLAN' },
      { value: 'RTRAD', label: 'RTRAD' },
      { value: 'RTRECORD', label: 'RTRECORD' },
      { value: 'RTSEGANN', label: 'RTSEGANN' },
      { value: 'RTSTRUCT', label: 'RTSTRUCT' },
      { value: 'RWV', label: 'RWV' },
      { value: 'SEG', label: 'SEG' },
      { value: 'SM', label: 'SM' },
      { value: 'SMR', label: 'SMR' },
      { value: 'SR', label: 'SR' },
      { value: 'SRF', label: 'SRF' },
      { value: 'STAIN', label: 'STAIN' },
      { value: 'TEXTUREMAP', label: 'TEXTUREMAP' },
      { value: 'TG', label: 'TG' },
      { value: 'US', label: 'US' },
      { value: 'VA', label: 'VA' },
      { value: 'XA', label: 'XA' },
      { value: 'XC', label: 'XC' },
    ],
  },
  isSortable: true,
  gridCol: 3,
};
export const _studyResearchTableColumns = [
  { key: 'patientId', title: 'Patient ID', sort: true},
  { key: 'patientName', title: 'Patient Name', sort: true },
  { key: 'dob', title: 'Age', sort: true },
  { key: 'gender', title: 'Gender' },
  { key: 'modality', title: 'Modality' },
  { key: 'studyRegion', title: 'Study' },
  { key: 'studyDate', title: 'Study Date' },
  { key: 'referringPhysician', title: 'Referring Physician' },
  { key: 'study_research_report', title: 'Report' },
];

export const _roleType = {
  superAdmin : 'Superadmin',
  hospitalSuperadmin : 'hospitalsuperadmin',
  frontDesk: 'Front Desk',
  teleRadiology: 'teleRadiology',
  radiologist: 'Radiologist',
  admin: 'Admin',
  nurse: 'Nurse',
  resident: 'Resident',
  clinician: 'Clinician',
  pathologist: 'Pathologist',
  technician: 'Technician',
  pathologistAdmin: 'Pathologist Admin',
  radiologistAdmin: 'Radiologist Admin',
  government: 'Government',
}

export const creditOptions = [100, 200, 500, 1000, 2000]

export const _purchase_type = {
  CREDIT: 'CREDIT',
  SUBSCRIPTION: 'SUBSCRIPTION',
  ADD_ONS: 'ADD_ONS',
  EXTRA_STORAGE: 'EXTRA_STORAGE',
  SUBSCRIPTION_WITH_ADDONS: 'SUBSCRIPTION_WITH_ADDONS'
}
